<template>
    <div>
        <multiselect class="form-control" v-model="modelo.idpais" :options="datos" track-by="id" label="nombre" 
        :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Seleccione..."></multiselect>

    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ model:Object,default:{type:Object,required:false,default:null} },
    data(){ 
        return{
            datos: [],
            modelo: {
                idpais: null,
            }
        }
    },
    watch:{
        'modelo.idpais': function(){this.model.idpais=this.modelo.idpais; },
        'default':function(a){
            if( a == null ) return;
            this.modelo.idpais = a;
        },
    },
    methods:{
        async getDatos() {
            var vue = this;
            var sql = gql`query{getPaises{id,nombre}}`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                vue.datos = data.data.getPaises;
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getPaises' ) )
            })
        },
    },
    mounted(){
        this.getDatos();
    }
}
</script>